import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AlertService, UIService } from 'src/app/_services';
import { defaultSearchOpts, SearchService } from 'src/app/_services/search.service';
import { Tag, TagService, tagTextColor } from 'src/app/_services/tag.service';
import { sizeInBytes } from 'src/app/_utils/utils';
import { FileInfo } from 'src/app/dashboard/file-explorer-page/file-explorer-page.types';
import { Project } from 'src/types/Project';

/** A project tag and the files that have it */
@Component({
    selector: 'app-project-tag-view',
    templateUrl: './project-tag-view.component.html',
    styleUrls: ['../partners/view/partner-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProjectTagViewComponent implements OnInit {
  projectId: string;
  tagId: string;
  /** the projects-list row passed in navigation state, for the heading */
  project: Project;
  tag: Tag;

  files: FileInfo[] = [];
  count = 0;
  page = 1;
  limit = defaultSearchOpts.limit;
  loading = true;

  sizeInBytes = sizeInBytes;
  tagTextColor = tagTextColor;

  constructor(
    private route: ActivatedRoute,
    private tagService: TagService,
    private searchService: SearchService,
    private alert: AlertService,
    private uiservice: UIService,
  ) { }

  ngOnInit() {
    this.uiservice.setTitle('View Tag');
    this.projectId = this.route.snapshot.paramMap.get('id');
    this.tagId = this.route.snapshot.paramMap.get('tagId');
    this.project = history.state?.data?.project;

    this.tagService.get(this.projectId, this.tagId).subscribe({
      next: ({ tag }) => this.tag = tag,
      error: () => this.alert.error('Failed to load the tag'),
    });
    this.getFiles();
  }

  get pages() {
    return Math.max(1, Math.ceil(this.count / this.limit));
  }

  getFiles() {
    this.loading = true;
    this.searchService.getFiles(this.projectId, { tags: this.tagId }, { ...defaultSearchOpts, pageNumber: this.page }).subscribe({
      next: ({ files, count }) => {
        this.files = files;
        this.count = count;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.alert.error('Failed to load the files with this tag');
      },
    });
  }

  /** Go to the previous (-1) or next (1) page, if there is one */
  paginate(step: number) {
    const page = this.page + step;
    if(page < 1 || page > this.pages) { return; }

    this.page = page;
    this.getFiles();
  }
}
